import PropTypes from 'prop-types';
import classNames from 'classnames';

import { formatPrice } from '@spotahome/soyuz-currency';

import { trans, useSoyuzExperiment } from '@spotahome/soyuz/client';

import styles from './Price.module.scss';

const i18n = {
  from: 'rentable_unit_price.label.from',
  perMonth: 'price_tag.label.per_month'
};

const Price = ({
  amount = 0,
  currencyCode = 'EUR',
  color = 'default',
  biggerFont = false,
  biggerFontMonthly = false,
  inline = false,
  className = ''
}) => {
  const SimplifyHomecardsDesign = useSoyuzExperiment(
    'SimplifyHomecardsDesignV2'
  );
  const isSimplifyHomecardsDesignVariant =
    SimplifyHomecardsDesign.get('behaviour') === 'variant';

  const wrapperClassName = classNames(
    styles.price,
    styles[`price--${color}`],
    className,
    {
      [styles['price--inline']]: inline
    }
  );

  const priceClassName = classNames(styles.price__amount, {
    [styles['price__amount--bigger-font']]: biggerFont
  });

  const priceMonthlyClassName = classNames(
    styles.price__monthly,
    styles['price__monthly--rebranding-style'],
    {
      [styles['price__monthly--bigger-font']]: biggerFontMonthly
    }
  );

  const [min, max] = `${amount}`.split('-'); // if it splits, its seasonal price
  const isSeasonalPrice = min && max;

  if (isSimplifyHomecardsDesignVariant) {
    return (
      <div className={wrapperClassName}>
        {isSeasonalPrice ? (
          <span
            className={classNames(priceMonthlyClassName, styles.price__from)}
          >
            {trans(i18n.from)}{' '}
          </span>
        ) : null}
        <span className={priceClassName}>{formatPrice(min, currencyCode)}</span>
        <span className={priceMonthlyClassName}> {trans(i18n.perMonth)}</span>
      </div>
    );
  }

  return (
    <div className={wrapperClassName}>
      <span className={priceClassName}>
        {formatPrice(amount, currencyCode)}
      </span>
      <span className={priceMonthlyClassName}>/{trans(i18n.perMonth)}</span>
    </div>
  );
};

Price.propTypes = {
  amount: PropTypes.number,
  currencyCode: PropTypes.string,
  color: PropTypes.oneOf(['default', 'light-black', 'interaction', 'dark']),
  biggerFont: PropTypes.bool,
  biggerFontMonthly: PropTypes.bool,
  inline: PropTypes.bool,
  className: PropTypes.string
};

export default Price;
